import { memo, VFC, useState, useEffect } from 'react';
import {
  Table,Thead,Tbody,Tr,Th,Td,
  Box,Flex,Input,
  Text,Center,ListItem,UnorderedList,
} from '@chakra-ui/react';
import { issueObj } from '../../types/issue';
import { ListButton } from '../atoms/button/ListButton';
import { MyText } from '../atoms/text/MyText';
import { IssueGroupDetailDialog } from '../organisms/modal/IssueGroupDetailDialog';
import { IssueDetailDialog } from '../organisms/modal/IssueDetailDialog';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";

type Props = {
  ptn: string;
  issueObjList: Array<issueObj>; // レコードデータ
  nextStr?: string;
};

export const IssueTable: VFC<Props> = memo((props) => {
  const { ptn, issueObjList, nextStr='' } = props;
  const { loginUser } = useLoginUser();
  const [ groupName, setGroupName ] = useState('');
  const [ issueArn, setIssueArn ] = useState('');
  const [ issueObjListTmp, setIssueObjListTmp ] = useState<Array<issueObj>>([]);
  
  const [ issueNum, setIsseNum ] = useState(0);
  const [ filterCloud, setFilterCloud ] = useState('');
  const [ filterRegion, setFilterRegion ] = useState('');
  const [ filterService, setFilterService ] = useState('');
  const [ filterKind, setFilterKind ] = useState('');
  const [ filterStatus, setFilterStatus ] = useState('');
  const [ filterAccount, setFilterAccount ] = useState('');
  
  // 配列の長さの確保
  useEffect(() => {
    setIsseNum(issueObjList.length);
    setIssueObjListTmp(issueObjList);
  }, [issueObjList]);
  
  // 検索絞り込み
  useEffect(() => {
    setIssueObjListTmp([...
      issueObjList.filter((item:issueObj)=>{
      return(
        (filterCloud  === '' || item.cloud_type.indexOf(filterCloud) >= 0) &&
        (filterRegion === '' || item.region_name.indexOf(filterRegion) >= 0) &&
        (filterService=== '' || item.service_name.indexOf(filterService) >= 0) &&
        (filterKind   === '' || item.health_kind.indexOf(filterKind) >= 0) &&
        (filterStatus === '' || item.status.indexOf(filterStatus) >= 0) &&
        (filterAccount=== '' || item.account_list.join(',').indexOf(filterAccount) >= 0)
      )})
    ]);
    
  }, [issueObjList,filterCloud,filterRegion,filterService,filterKind,filterStatus,filterAccount]);

  return (
    <>
    <Box id="issueList" margin="10px">
      <Flex alignItems="flex-end">
        <Text fontSize="lg">
          {ptn === 'current' ? (
            `■現在発生中および直近の障害（${issueNum}件）`
          ) : (
            `■障害一覧（${issueNum}件${nextStr}）`
          )}
        </Text>
      </Flex>
      <Box marginLeft="20px" marginBottom="10px">
        <UnorderedList color="tomato" fontSize="sm">
          <ListItem>この一覧はクラウドから通知された障害情報のうち、利用実績からお客様環境への影響可能性のあるものを掲載しています。<br />必ずしも、お客様システムで障害が発生しているとは限りませんので、参考情報の１つとしてご利用ください。</ListItem>
          <ListItem>障害グループとは、同時期に発生した障害をまとめて名前を付けたものです。</ListItem>
        </UnorderedList>
      </Box>
      {/* 以下リスト */}
      {issueNum === 0 && ptn === 'current' ? (
        <Center>
          <Text fontSize="lg" marginTop="20px" marginBottom="30px">発生中の障害はありません</Text>
        </Center>
      ) : issueNum === 0 ? (
        <Center>
          <Text fontSize="lg" marginTop="20px" marginBottom="30px">ご指定の条件に該当する障害はありません</Text>
        </Center>
      ) : (
        <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
          <Thead background="#aaaaaa">
            <Tr>
            <Th color="white" fontSize="sm">No.</Th>
            <Th color="white" fontSize="sm" colSpan={2}>障害グループ名</Th>
            <Th color="white" fontSize="sm">クラウド種別<Input id="filterCloud" onChange={(e)=>setFilterCloud(e.target.value)} value={filterCloud} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">リージョン<Input id="filterRegion" onChange={(e)=>setFilterRegion(e.target.value)} value={filterRegion} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">サービス<Input id="filterService" onChange={(e)=>setFilterService(e.target.value)} value={filterService} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">種別<Input id="filterKind" onChange={(e)=>setFilterKind(e.target.value)} value={filterKind} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">状況<Input id="filterStatus" onChange={(e)=>setFilterStatus(e.target.value)} value={filterStatus} size='xs' placeholder="部分一致" /></Th>
            <Th color="white" fontSize="sm">障害発生期間</Th>
            {loginUser.userGroup === 'exec' ? (
              <Th color="white" fontSize="sm">お客様名（アカウント数）</Th>
            ) : (
              <Th color="white" fontSize="sm">アカウントID（お客様名）<Input id="filterAccount" onChange={(e)=>setFilterAccount(e.target.value)} value={filterAccount} size='xs' placeholder="完全一致" /></Th>
            )}
            <Th color="white" fontSize="md"></Th>
          </Tr>
          </Thead>
          <Tbody>
          {issueObjListTmp.map((item:issueObj, index:number) => (
            <Tr key={index} verticalAlign="top">
              <Td>{index+1}</Td>
              {index > 0 && issueObjListTmp[index-1].group_name === item.group_name ? (
                <>
                <Td></Td>
                <Td>同上</Td>
                <Td></Td>
                <Td></Td>
                </>
              ) : (
                <>
                <Td>{item.group_name}</Td>
                <Td>{item.group_name ? <ListButton onClick={()=>setGroupName(item.group_name)}>詳細</ListButton> : "グループ名未設定"}</Td>
                <Td>{item.cloud_type}</Td>
                <Td>{item.region_name}</Td>
                </>
              )}
              <Td>{item.service_name}</Td>
              <Td><MyText size='xs' str={item.health_kind} /></Td>
              <Td>{item.status}</Td>
              <Td>{item.start_time}～{item.end_time}</Td>
              <Td>{typeof item.account_list !== 'undefined' && item.account_list.map((item:string,index:number) => (
                 <Text key={index} align="left">{item}</Text>
              ))}</Td>
              <Td>
                <ListButton onClick={()=>setIssueArn(item.health_arn)}>個別情報</ListButton>
              </Td>
            </Tr>
          ))}
          </Tbody>
        </Table>
      )}
    </Box>
    {groupName !== '' && (
      <IssueGroupDetailDialog groupName={groupName} setGroupName={setGroupName} />
    )}
    {issueArn !== '' && (
      <IssueDetailDialog issueArn={issueArn} setIssueArn={setIssueArn} />
    )}
    </>
  );
});

